import React, { PureComponent } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import PropTypes from 'prop-types';

registerLocale('ru', ru);

class DatePickerField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }),
  };

  static defaultProps = {
    meta: null,
  };

  constructor() {
    super();
    this.state = {
      startDate: null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    /* eslint react/prop-types: 0 */
    const { value } = this.props;

    if (value instanceof Date) {
      this.setState({ startDate: value });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    if (value instanceof Date) {
      this.setState({ startDate: value });
    }
  }

  handleChange(date) {
    const { onChange } = this.props;
    this.setState({
      startDate: date,
    });
    onChange(date);
  }

  render() {
    const { meta } = this.props;
    const { startDate } = this.state;

    return (
      <div className="date-picker">
        <DatePicker
          className="form__form-group-datepicker"
          selected={startDate}
          onChange={this.handleChange}
          dateFormat="dd.MM.yyyy"
          locale="ru"
          dropDownMode="select"
          showMonthDropdown
          showYearDropdown
        />
        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
      </div>
    );
  }
}

const renderDatePickerField = (props) => {
  const { input, meta } = props;
  return <DatePickerField {...input} meta={meta} />;
};

renderDatePickerField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderDatePickerField.defaultProps = {
  meta: null,
};

export default renderDatePickerField;
